"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var values_1 = require("../../utils/values");
var Div_1 = __importDefault(require("../Div"));
var Text_1 = __importDefault(require("../Text"));
var styles_1 = require("../../utils/styles");
var ListPrice = function (_a) {
    var styles = _a.styles, templateChildren = _a.templateChildren, listPrice = _a.listPrice, id = _a.id;
    if (listPrice) {
        var _b = (0, values_1.convertRetailProductPrice)(listPrice), integers = _b.integers, decimals = _b.decimals;
        return (react_1.default.createElement(Div_1.default, { styles: styles, id: id },
            react_1.default.createElement(Text_1.default, { id: "price-integers-".concat(id), styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, 0), value: integers || '' }),
            react_1.default.createElement(Text_1.default, { id: "price-decimals-".concat(id), styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, 1), value: decimals || '' })));
    }
    return react_1.default.createElement(react_1.Fragment, null);
};
exports.default = ListPrice;
//# sourceMappingURL=ListPrice.js.map